import React from 'react'

export default function Contact() {
  return (
    <div id="contact">
      <p className="contact_title">CONTACTEZ NOUS POUR RECEVOIR VOTRE FORMATION</p>
      <div className="contact_info">
        <p className="mail">3wcode@gmail.com</p>
        <p className="mail">06.66.66.66.66</p>
      </div>
      <div className="copyright">
        &copy; 3W-CODE, 2019 - 2020
      </div>
    </div>
  )
}
